import { NodeContextProvider } from '@/node-editor';
import { Render } from '@/nodes/root';
import { TWidgets } from '@/widget-editor';
import React from 'react';

interface IProps {
  value: TWidgets;
}

export const RenderComponent = ({ value }: IProps) => {
  const widgetsChanged = (prev: TWidgets, next: TWidgets): boolean => {
    return Object.values(next).some(
      (widget) => JSON.stringify(widget) !== JSON.stringify(prev[widget.id])
    );
  };

  return (
    <React.Suspense fallback="">
      <NodeContextProvider value={{ ...value }} readOnly>
        {({ nodes, dispatch }) => {
          const widgets: TWidgets = { ...nodes } as any;
          // invalidate and rerender if any node is changed.
          if (widgetsChanged(widgets, value)) {
            dispatch({ type: 'NODES_RESET', payload: { ...value } });
            return;
          }

          return <Render />;
        }}
      </NodeContextProvider>
    </React.Suspense>
  );
};
